import { AfterViewInit, Component, OnInit } from '@angular/core';
import { KPIService } from '../../../services';
import { VmeInboxJobsService } from '../../../services';

@Component({
  selector: 'dashboard-engineius-kpis-toplevel',
  templateUrl: './dashboard-engineius-kpis-toplevel.component.html',
})
export class DashboardEngineiusKPIsTopLevelComponent implements OnInit, AfterViewInit {
  constructor(private kpiService: KPIService, private vmeInboxJobsService: VmeInboxJobsService) {}

  tabs: any;

  async ngOnInit() {
    this.tabs = await this.kpiService.getDashboardTabs();
  }

  async ngAfterViewInit() {}
}
